"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _models = require("@nopanoga/models");

var _reactHooks = require("@knxlab/react-hooks");

var _Text = require("../Text");

var _BottomButton = require("../Button/BottomButton");

var _SnapScrollview = _interopRequireDefault(require("../SnapScrollview"));

var _ListItem = _interopRequireDefault(require("./ListItem"));

var _RestItem = _interopRequireDefault(require("./RestItem"));

var _ExerciceItem = _interopRequireDefault(require("./ExerciceItem"));

var _EmptyPlaceholder = _interopRequireDefault(require("./EmptyPlaceholder"));

var _StartCountDown = _interopRequireDefault(require("./StartCountDown"));

var _Header = _interopRequireDefault(require("./Header"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _EndScreen = _interopRequireDefault(require("./EndScreen"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = _reactNative.StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    flex: 1,
    backgroundColor: _Theme.colors.appBackground
  },
  listContainer: {
    flex: 1,
    borderWidth: 0
  },
  absoluteCountDown: {
    position: 'absolute',
    zIndex: 15,
    height: '100%',
    width: '100%',
    backgroundColor: _Theme.colors.appBackground
  }
});

var Container = function Container(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ["style"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, _extends({}, props, {
    style: [styles.container, style]
  }));
};

var _default = function _default(_ref2) {
  var trainingSession = _ref2.trainingSession,
      _ref2$onClickClose = _ref2.onClickClose,
      onClickClose = _ref2$onClickClose === void 0 ? function () {} : _ref2$onClickClose;
  var listRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      sessionTimer = _useState2[0],
      setSessionTimer = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      started = _useState4[0],
      setStarted = _useState4[1]; // @TODO set this to false in prod


  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      ended = _useState6[0],
      setEnded = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      stats = _useState8[0],
      setStats = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      activeIndex = _useState10[0],
      setActiveIndex = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      size = _useState12[0],
      setSize = _useState12[1];

  var exercices = trainingSession.getFlattenExercices();
  var exercicesLength = exercices.length;
  var activeExercice = exercices[activeIndex];
  var isResting = activeExercice.type === 'rest';
  (0, _reactHooks.useInterval)(function () {
    setSessionTimer(sessionTimer + 1);
  }, !ended && started ? 1000 : null);

  var next = function next() {
    if (listRef.current) {
      listRef.current.next();
    }

    if (activeIndex === exercicesLength - 1) {
      setStats({
        time: sessionTimer
      });
      setEnded(true);
    }
  };

  var prev = function prev() {
    if (listRef.current) {
      listRef.current.prev();
    }
  };

  if (trainingSession.isEmpty()) {
    return /*#__PURE__*/_react["default"].createElement(_EmptyPlaceholder["default"], {
      trainingSession: trainingSession
    });
  }

  if (ended) {
    return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_EndScreen["default"], {
      stats: stats,
      onClickClose: onClickClose
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(Container, null, !started && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.absoluteCountDown
  }, /*#__PURE__*/_react["default"].createElement(_StartCountDown["default"], {
    onEnd: function onEnd() {
      return setStarted(true);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    onClickClose: onClickClose
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.listContainer,
    onLayout: function onLayout(_ref3) {
      var _ref3$nativeEvent$lay = _ref3.nativeEvent.layout,
          width = _ref3$nativeEvent$lay.width,
          height = _ref3$nativeEvent$lay.height;

      if (size && size.itemHeight === height && size.itemWidth === width) {
        return false;
      }

      setSize({
        itemWidth: width,
        itemHeight: height
      });
    }
  }, size && /*#__PURE__*/_react["default"].createElement(_SnapScrollview["default"], _extends({
    ref: listRef,
    exercices: exercices
  }, size, {
    onIndexChange: function onIndexChange(index) {
      setActiveIndex(index);
    },
    disableNavigation: isResting,
    renderItem: function renderItem(item, index, itemWidth, itemIndex, isActive) {
      var key = itemIndex;

      if (item.type === 'rest') {
        return /*#__PURE__*/_react["default"].createElement(_RestItem["default"], {
          item: item,
          isActive: started && isActive,
          index: itemIndex,
          totalExercices: exercicesLength,
          width: itemWidth,
          onStart: function onStart() {},
          onEnd: function onEnd() {
            next();
          }
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_ExerciceItem["default"], {
        key: item.id,
        item: item,
        isActive: started && isActive,
        index: itemIndex,
        totalExercices: exercicesLength,
        width: itemWidth,
        onEnd: function onEnd() {
          next();
        }
      });
    }
  }))), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    exercicesLength: exercicesLength,
    sessionTimer: sessionTimer,
    activeIndex: activeIndex,
    onPressPrev: function onPressPrev() {
      return prev();
    },
    onPressNext: function onPressNext() {
      return next();
    }
  }));
};

exports["default"] = _default;